import React from 'react'

function Divider({className, text, vertical = false}: {className?: string; text?: string; vertical?: boolean}) {
  return vertical ? (
    <div className={`w-px min-h-4 h-full bg-sub-500 ${className ?? ''}`}></div>
  ) : (
    <div className={`h-px w-full bg-background/10 relative ${className ?? ''}`}>
      {text && <span className="absolute left-1/2 -translate-1/2 bg-black px-3 text-xs text-sub-400">{text}</span>}
    </div>
  )
}

export default Divider
